exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".column-root-2pW {\n}\n\n@media only screen and (max-width: 768px) {\n    .column-root-2pW {\n        background-attachment: scroll !important;\n        flex-basis: 100%;\n    }\n}\n", ""]);

// Exports
exports.locals = {
	"root": "column-root-2pW"
};